import Landing from "./Landing/Landing";
import Navbar from "./NavBar/NavBar";
import ShowLatestSaleProducts from "./Product/SaleProducts/ShowLatestSaleProducts";
import IntensiveSection from "./Sections/IntensiveSection";
import SubjectsSection from "./Sections/SubjectsSection";
import ExcellentStudentsSection from "./Sections/ExcellentStudentsSection";

export default function Home() {
  return (
    <div>
      <Navbar />
      <div>
        <Landing />
        <ExcellentStudentsSection />
        <SubjectsSection />
        <IntensiveSection />
        <ShowLatestSaleProducts />
      </div>
    </div>
  );
}
